
export const staticDir = '/static/'

export const profile = {
  name: 'Kyle He',
  avatar: 'avatar.jpg',
  description: 'Web Developer'
}

export const links = [
  {
    name: 'Blog',
    icon: 'news.svg',
    href: '/blog/',
    tags: ['publication']
  },
  {
    name: 'Github',
    icon: 'github.svg',
    href: 'https://github.com/599316527/',
    tags: ['publication', 'programming']
  },
  {
    name: 'Twitter',
    icon: 'twitter.svg',
    href: 'https://twitter.com/kyleehee',
    tags: ['publication', 'sns']
  },
  {
    name: 'Instagram',
    icon: 'instagram.svg',
    href: 'https://www.instagram.com/ohyeskyle/',
    tags: ['publication', 'sns']
  },
  // {
  //   name: 'Steam',
  //   icon: 'steam.svg',
  //   href: 'https://steamcommunity.com/id/kyleehe/',
  //   tags: ['game', 'sns']
  // },
  // {
  //   name: 'PS4',
  //   icon: 'playstation.svg',
  //   href: 'https://my.playstation.com/kyleehe',
  //   tags: ['game', 'sns']
  // },
  {
    name: 'Telegram',
    icon: 'telegram.svg',
    href: 'https://telegram.me/kyleehee',
    tags: ['contact', 'im']
  },
  {
    name: 'iMessage',
    icon: 'imessage.svg',
    href: '#/page/imessage/',
    tags: ['contact', 'im']
  },
  {
    name: 'Mail',
    icon: 'mail.svg',
    href: '#/page/mail/',
    tags: ['contact']
  },
  {
    name: 'Paypal',
    icon: 'paypal.svg',
    href: 'https://paypal.me/kyleehe',
    tags: ['contact', 'payment']
  },
  {
    name: 'Alipay',
    icon: 'alipay.svg',
    href: '#/page/alipay/',
    tags: ['contact', 'payment']
  },
  {
    name: 'Zhihu',
    icon: 'zhihu.png',
    href: 'https://www.zhihu.com/people/ohyes',
    tags: ['publication', 'sns']
  },
  // {
  //   name: 'Vifeng',
  //   icon: 'vifeng.svg',
  //   href: '/vifeng/',
  //   tags: ['product']
  // }
]

export const pages = [
  {
    name: 'iMessage',
    icon: 'imessage.svg',
    album: '',
    value: 'ohyes@hk1229.cn'
  },
  {
    name: 'Mail',
    icon: 'mail.svg',
    album: '',
    value: 'me@kylehe.me'
  },
  {
    name: 'Alipay',
    icon: 'alipay.svg',
    album: 'alipay-qrcode.png',
    value: 'hekai@vista.aero'
  }
]



// WEBPACK FOOTER //
// ./src/data.js